export default __webpack_public_path__ + "static/media/whatsapp.5c20c86b.png";